package ru.villawonka.app.domain.model

object Deeplink {

    object Telegram {

        fun chat(username: String, text: String): String =
            "https://t.me/$username?text=$text"

        fun share(url: String, text: String): String =
            "https://t.me/share/url?url=$url&text=$text\""

        fun post(postType: PostTypeDomain, postId: Int, miniAppUrl: String) =
            "$miniAppUrl?startapp=${postType.name.lowercase()}_$postId"
    }
}